<template>
<div id="container" class="container gewinn">
    <top-menu />
    <top-logo />
    <stoppuhr />
    <lautsprecher />
    <copyright />
    <div class="fullscreen_background">
        <img src="/static/assets/gewinn/Hintergrund_2860.jpg" />
    </div>

    <div class="content">
            <div class="inner">
                    <div class="ueberschrift">
                            <img src="/static/assets/gewinn/album_voll_toll.png" />
                    </div>
                    <div class="content_text">
                            <p>
                              Freu dich auf dein Hugidubies-Geschenk!
<br /><br />
Wenn du alle Hugidubies-Sticker gesammelt und in dein Album eingeklebt hast, dann komm in deine Hugendubel Buchhandlung! Dort bekommst du einen Stempel in dein Stickeralbum und ein super cooles Hugidubies-Kazoo als Geschenk. <br /><br />
Du hast noch kein Hugidubies-Stickeralbum und keine Hugidubies-Sticker? Dann komm in deine Hugendubel Buchhandlung. An der Kasse bekommst du das Album und alle vier Wochen neue Sticker gratis! <br /><br />
* Der Abbildung ähnlich.
                              
						</p>
                    </div>
            </div>
    </div>
  <div class="z50 active textplaybutton pointer" @click="starttextplay"><img src="/static/assets/alle/Play_Button.png"/></div>
    <div class="rucksack">
            <div class="inner">
                    <img class="bg rotating" src="/static/assets/gewinn/Beutel_Shine.png" />
                    <img class="img" src="/static/assets/gewinn/Hugidubies_kazoo_rgb.png" />
            </div>
    </div>

    <div class="gigi gigi_animation">
            <img class="img" src="/static/assets/gewinn/gigi.png" />
    </div>
    <div class="hui hui_animation">
            <img class="img" src="/static/assets/gewinn/hui.png" />
    </div>
    <div class="libero libero_animation">
            <img class="img" src="/static/assets/gewinn/libero.png" />
    </div>
    <div class="dubix dubix_animation">
            <img class="img" src="/static/assets/gewinn/dubix.png" />
    </div>
</div>
</template>

<script>
/* eslint no-trailing-spaces: "off" */
/* eslint whitespace: "off" */
/* eslint indent: "off" */
/* eslint keyword-spacing: "off" */
/* eslint no-unused-vars: "off" */
import Topmenu from '@/components/Topmenu.vue'
import Toplogo from '@/components/Toplogo.vue'
import Stoppuhr from '@/components/Stoppuhr.vue'
import Lautsprecher from '@/components/Lautsprecher.vue'
import Copyright from '@/components/Copyright.vue'
var muted

export default {
  name: 'Gewinn',
  data () {
    return {
      who: 'Gewinn'
    }
  },
  components: {
    'top-menu': Topmenu,
    'top-logo': Toplogo,
    'stoppuhr': Stoppuhr,
    'lautsprecher': Lautsprecher,
    'copyright': Copyright
  },
  methods: {
    starttextplay () {
      console.log('starttextplay')
        try {
            window.currentAudioX.pause()
            window.currentAudioX.currentTime = 0
            window.currentAudioX = null
        } catch (e) {
            console.log('pause geht nicht')
        }
        window.currentAudioX = new Audio('https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies2022_Update_Gewinnseite_Kazoo3.mp3')
        window.currentAudioX.muted = muted
        window.currentAudioX.play()
    }    
  },
  mounted () {
    this.$ga.page(this.$router)
    var muted = (typeof window.muted === 'undefined' ? false : window.muted)
    var self = this
    setTimeout(function () {
      if (typeof window.currentAudioX !== 'undefined') {
        try {
        window.currentAudioX.pause()
        window.currentAudioX.currentTime = 0
        window.currentAudioX = null
        } catch(e) {}
      }
      window.currentAudioX = new Audio('https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies2022_Update_Gewinnseite_Kazoo3.mp3')
      window.currentAudioX.muted = window.muted
      window.currentAudioX.play()
    }, 1000)
  },
  beforeDestroy () {
    try {
      window.currentAudioX.pause()
    } catch (e) {}
    try {
      window.currentAudio.pause()
    } catch (e) {}
    try {
      window.hintergrundSound.pause()
    } catch (e) {}
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
body {margin:0; padding:0;}


/* Z-Index - Level */

.z1{z-index:10;}
.z2{z-index:20;}
.z3{z-index:30;}
.z4{z-index:40;}
.z5{z-index:50;}
.z6{z-index:60;}
.z7{z-index:70;}
.z8{z-index:80;}
.z9{z-index:90;}
.z10{z-index:100;}
.z11{z-index:110;}
.z12{z-index:120;}
.z13{z-index:130;}
.z14{z-index:140;}
.z15{z-index:150;}
.z16{z-index:160;}
.z17{z-index:170;}
.z18{z-index:180;}
.z19{z-index:190;}
.z20{z-index:200;}
.z21{z-index:210;}
.z22{z-index:220;}
.z23{z-index:230;}
.z24{z-index:240;}
.z25{z-index:250;}
.z26{z-index:260;}
.z27{z-index:270;}
.z28{z-index:280;}
.z29{z-index:290;}
.z30{z-index:300;}
.z31{z-index:310;}
.z32{z-index:320;}
.z33{z-index:330;}
.z34{z-index:340;}
.z35{z-index:350;}
.z36{z-index:360;}
.z37{z-index:370;}
.z38{z-index:380;}
.z39{z-index:390;}
.z40{z-index:400;}
.z41{z-index:410;}
.z42{z-index:420;}
.z43{z-index:430;}
.z44{z-index:440;}
.z45{z-index:450;}
.z46{z-index:460;}
.z47{z-index:470;}
.z48{z-index:480;}
.z49{z-index:490;}
.z50{z-index:500;}

.gewinn .himmel { position: fixed; top: 0px; left: 0; width: 100%; height: auto; }
.gewinn .content { position: fixed; top: 25%; left: 15%; width: 500px; height: auto;  font-size: 16pt; font-family: 'Open Sans'; font-weight: 400;}
.gewinn .content .inner {position:relative;}
.gewinn .content .inner .ueberschrift { position: absolute; top: 0; left: 0; width: 100%; height: auto;}
.gewinn .content .inner .content_text  { position: absolute; top: 50px; left: 0; width: 100%; height: auto;}
.gewinn .content .inner .content_text span { font-family: FrozenMemory; }

.gewinn .rucksack { position: fixed; top: 50px; right: 5vw; width: 50%; height: 800px;  }
.gewinn .rucksack .inner {position: relative;}
.gewinn .rucksack .inner .bg {position: absolute; top: 0; left: 0; }
.gewinn .rucksack .inner .img {position: absolute; top: 350px; left: 190px;}
.gewinn .rucksack {animation: rucksack_erscheint 1s ease-out; animation-delay: 0s; animation-fill-mode: forwards; opacity:0; transform-origin:center center;}
@keyframes rucksack_erscheint {
    0% { transform: scale(0.5); opacity:0;}
    50% { transform: scale(0.5); opacity:0;}
    80% { transform: scale(1.1); opacity:1;}
    100% { transform: scale(1); opacity:1;}
}

.gewinn .gigi { position: fixed; bottom: -160px; left: 986px; height: auto; }
.gewinn .gigi img {animation: gigi_erscheint 0.25s ease-out; animation-delay: 0.25s; animation-fill-mode: forwards; margin-bottom: -500px;}
@keyframes gigi_erscheint {
    0% { margin-bottom: -500px; opacity:0;}
    100% { margin-bottom: 0; opacity:1;}
}
.gewinn .hui { position: fixed; bottom: -270px; left: 666px; height: auto; }
.gewinn .hui img {animation: hui_erscheint 0.25s ease-out; animation-delay: 0.5s; animation-fill-mode: forwards; margin-bottom: -500px;}
@keyframes hui_erscheint {
    0% { margin-bottom: -500px; opacity:0;}
    100% { margin-bottom: 0; opacity:1;}
}
.gewinn .libero { position: fixed; bottom: -290px; left: 277px; height: auto;  }
.gewinn .libero img {animation: libero_erscheint 0.25s ease-out; animation-delay: 0.75s; animation-fill-mode: forwards; margin-bottom: -500px;}
@keyframes libero_erscheint {
    0% { margin-bottom: -500px; opacity:0;}
    100% { margin-bottom: 0; opacity:1;}
}
.gewinn .dubix { position: fixed; bottom: -230px; left: 1353px; height: auto; }
.gewinn .dubix img { animation: dubix_erscheint 0.25s ease-out; animation-delay: 1s; animation-fill-mode: forwards; margin-bottom: -500px;}
@keyframes dubix_erscheint {
    0% { margin-bottom: -500px; opacity:0;}
    100% { margin-bottom: 0; opacity:1;}
}   
.gewinn .content p {
    width: 130%;
}
@-webkit-keyframes rotating /* Safari and Chrome */ {
  from {
    -webkit-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes rotating {
  from {
    -ms-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -ms-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
.rotating {
  -webkit-animation: rotating 10s linear infinite;
  -moz-animation: rotating 10s linear infinite;
  -ms-animation: rotating 10s linear infinite;
  -o-animation: rotating 10s linear infinite;
  animation: rotating 10s linear infinite;
}

.z50.active.textplaybutton.pointer {
    position: absolute;
    top: 241px;
    left: 725px;
}
.z50.active.textplaybutton.pointer img {
    width: 100px;
}


</style>



// WEBPACK FOOTER //
// src/components/Gewinn.vue